import styled from 'styled-components';
import { grayColor } from "~/components/layout/Variables";

export const SubTitle = styled.p`
  font-size: 0.95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const Available = styled.div`
  font-size: 0.95rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  font-family: 'Roboto';
  text-align: center;
  margin-left: 0.3rem;
  background-color: #fff;
  color: #808080;
  width: 100%;
  margin: 0.5rem 0.5rem 0.5rem 0rem;

  @media (max-width: 770px) {
    margin: 0rem 0.5rem 0.5rem 0rem;
  }
`;

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 1.5rem auto 1.5rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const CardCustom = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: initial;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 0.25rem;
  padding: 0 0 1rem 0;
  margin-bottom: 1rem;
  box-shadow: 0px 2px 2px #00000029;
`

export const CardInput = styled.div`
  margin: 1rem 1rem;
  @media (max-width: 770px) {
    margin: 0rem 1rem;
  }
`;

export const ContainerCard = styled.div`
  margin-top: 0rem;
`;

export const CenterHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  font-size: 0.95rem;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }

  @media (min-width: 700px) {
    text-align: center;
  }
`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }

  @media (max-width: 770px) {
    margin-left: 0.5rem;
  }
`;

export const ContainerCustom = styled.div`
  background-color: rgb(230, 223, 223);
  padding: 0.2rem 0rem;
  margin-top: 1.5rem;
  border-radius: 0.3rem;
  box-shadow: 0px 2px 2px #00000029;

  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const InputApply = styled.input`
  color: ${(props) => props.disabled && "#808080"};
  font-size: 0.95rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  font-family: 'Roboto';
  text-align: center;
  background-color: #fff;
  border: ${(props) => props.disabled ? "1px" : "1px solid #b0b0b0"};
  border-radius: 0.3rem;
  width: 100%;
  box-shadow: ${(props) => !props.disabled && "0px 2px 2px #00000029"};
`;

export const LeftHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 500px) {
    font-size: 0.75rem;
  }
  @media (max-width: 450px) {
    font-size: 0.65rem;
  }
`;

export const LefItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  margin-top: 0.3rem;
  margin-bottom: 0rem;
  font-size: 0.95rem;
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const TextQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin-left: 0.5rem;
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 0 0;
    display: flex;
    align-items: center;
  }
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin-right: 1rem;
    }
  }

`;

export const ValueQuantity = styled(SubTitle)`
  text-align: right;
  font-weight: bold;
`;

export const IconInformationBlue = {
  width: 27,
  height: 30,
};

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;